import { AxiosInstance, AxiosResponse } from 'axios';
import { CustomerGrantCreateDto } from './inputs/customer-grant-create.input';
import { CreateGrantResponse } from './responses/customer-grant-create.response';

export class CustomerModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async setGrant(dto: CustomerGrantCreateDto): Promise<AxiosResponse<CreateGrantResponse>> {
    return await this.client.post('/customer/grants', dto);
  }
}
